<template>
  <v-card class="pa-4 pa-md-14 rounded-0" flat>
    <v-card-title class="section-title pa-2" style="color: inherit !important">
      {{ value.title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2" style="color: inherit !important">
      {{ value.description }}
    </v-card-subtitle>

    <v-row no-gutters>
      <v-col class="mt-16 pa-sm-16 ma-md-0 pa-md-0" cols="12">
        <v-card class="transparent" flat width="100%">
          <v-img
            :src="images[0]"
            class="elevation-3 rounded-lg"
            style="
              margin-right: 10%;
              margin-bottom: -15%;
              position: relative;
              z-index: 1;
            "
            width="45%"
          />
          <v-img
            :src="images[1]"
            class="mr-auto elevation-3 rounded-lg"
            width="55%"
          />
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card-text class="mt-4 px-0">
          <v-expansion-panels flat>
            <v-expansion-panel
              v-for="(item, i) in value.items"
              :key="i"
              class="mb-2"
            >
              <v-expansion-panel-header
                style="font-size: 8pt; line-height: 1.2rem; font-weight: bolder"
              >
                {{ item.question }}
              </v-expansion-panel-header>
              <v-expansion-panel-content
                style="font-size: 7pt; line-height: 1.2rem"
              >
                <div v-html="item.answer" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "bFaqView",

  props: {
    value: Object,
    color: String,
  },

  computed: {
    images() {
      return !!this.value.design?.gallery[0]?.images?.length
        ? this.value.design.gallery[0].images.map((item) => item.url)
        : "";
    },
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
}

.v-expansion-panel {
  border: thin solid rgba(0, 0, 0, 0.2);
}
</style>
